import type { SearchMessages } from '../types';

const messages: SearchMessages = {
  'search.SearchBar.label': '搜索',
  'search.SearchModal.errorScreen.helpText': '你可能需要检查网络连接。',
  'search.SearchModal.errorScreen.titleText': '无法获取结果',
  'search.SearchModal.footer.closeKeyAriaLabel': 'Esc 键',
  'search.SearchModal.footer.closeText': '关闭',
  'search.SearchModal.footer.navigateDownKeyAriaLabel': '向下键',
  'search.SearchModal.footer.navigateText': '导航',
  'search.SearchModal.footer.navigateUpKeyAriaLabel': '向上键',
  'search.SearchModal.footer.searchByText': '搜索提供',
  'search.SearchModal.footer.selectKeyAriaLabel': 'Enter 键',
  'search.SearchModal.footer.selectText': '选中',
  'search.SearchModal.noResultsScreen.noResultsText': '没有结果：',
  'search.SearchModal.noResultsScreen.reportMissingResultsLinkText': '请告知我们。',
  'search.SearchModal.noResultsScreen.reportMissingResultsText': '认为这个查询应该有结果？',
  'search.SearchModal.noResultsScreen.suggestedQueryText': '试试搜索',
  'search.SearchModal.placeholder': '搜索文档',
  'search.SearchModal.searchBox.cancelButtonText': '取消',
  'search.SearchModal.searchBox.resetButtonTitle': '清除查询',
  'search.SearchModal.startScreen.favoriteSearchesTitle': '收藏',
  'search.SearchModal.startScreen.noRecentSearchesText': '没有最近搜索',
  'search.SearchModal.startScreen.recentSearchesTitle': '最近搜索',
  'search.SearchModal.startScreen.removeFavoriteSearchButtonTitle': '从收藏列表中删除这个搜索',
  'search.SearchModal.startScreen.removeRecentSearchButtonTitle': '从历史记录中删除这个搜索',
  'search.SearchModal.startScreen.saveRecentSearchButtonTitle': '保存这个搜索',
} as const;

export default messages;
